<template>
	<AppPopup ref="popup" :title="getString('item_redeemed')">
		<div class="redeemed-popup-content" v-if="redeemedItemData">
			<p v-if="!!title" class="redeemed-popup-subtitle" :style="'color:'+color">{{ title }}<span :style="'color:'+color" v-show="!!subtitle"> - {{ subtitle }}</span></p>
			<div class="redeemed-popup-item">
				<img v-if="redeemedItemData?.picture" :src="redeemedItemData?.picture" class="redeemed-item-image" :alt="getString('redeemed_item_picture')" />
				<div class="redeemed-item-info">
					<p class="redeemed-item-name">{{ redeemedItemData?.name }}</p>
					<div class="item-products" v-if="redeemedItemData?.products?.length > 0">
						<p class="item-product" :key="prodIndex" v-for="(product, prodIndex) in redeemedItemData.products">
							+ {{ product.product_name }} <span v-show="product.quantity !== 1">x{{ product.quantity }}</span>
						</p>
					</div>
				</div>
				<div class="redeemed-item-info quantity-wrapper">
					<p class="redeemed-item-quantity">x <b>{{ redeemedItemData?.current_redeemed_quantity }}</b></p>
				</div>
			</div>
		</div>
		<AppButton class="mt-10" icon-left="icon-qr-scan-white" :text="getString('scan_another_qr')" @click="openScanner"/>
	</AppPopup>
</template>

<script>
import AppPopup from "@/shared/components/AppPopup.vue";
import AppButton from "@/shared/components/AppButton.vue";
import {useLanguageStore} from "@/shared/stores";
import {useOrdersStore, useCounterStore} from "@/console-new/stores";

export default {
	setup() {
		const languageStore = useLanguageStore();
		const ordersStore = useOrdersStore();
		const counterStore = useCounterStore();
		return {getString: languageStore.getString, ordersStore, counterStore};
	},
	name: "RedeemedItemPopup",
	components: {AppPopup, AppButton},
	data() {
		return {
			redeemedItemData: null,
			title: null,
			subtitle: null,
			color: null,
		}
	},
	methods: {
		reset() {
			this.redeemedItemData = null;
			this.title = null;
			this.subtitle = null;
			this.color = null;
		},
		show(itemData) {
			this.reset();
			this.redeemedItemData = itemData;
			this.updateValues();
			this.$nextTick(() => this.$refs["popup"].toggleStatus(true));
		},
		updateValues() {
			let itemData = this.redeemedItemData;
			if(!itemData) { return }
			let searchingArray = this.ordersStore?.orderGroups || [];
			let group = searchingArray.find(g => g.orders.some(o => Number(o.order_id) === Number(itemData.order_id)));
			if(group) {
				this.title 		= group?.title 			|| null;
				this.subtitle 	= group?.subtitle 		|| null;
				this.color 		= group?.statusColor 	|| null;
				this.updateStoreValues(group);
			}
		},
		openScanner() {
			this.$refs["popup"].toggleStatus(false);
			this.counterStore.qrScannerActive = true;
		},
		updateStoreValues(ordersGroup) {
			if(!ordersGroup) { return }
			this.ordersStore.selectedGroupId = ordersGroup.groupIdentifier;
			let order = ordersGroup.orders.find(o => Number(o.order_id) === Number(this.redeemedItemData.order_id));
			let item = order?.items?.find(i => Number(i.order_item_id) === Number(this.redeemedItemData.order_item_id));
			if(item) {
				item.redeemed = (item.redeemed || 0) + this.redeemedItemData.current_redeemed_quantity;
				this.redeemedItemData.products = item.products || [];
			}
		}
	},
}
</script>

<style lang="scss" scoped>
.redeemed-popup-content {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 12px;
	width: 100%;

	.redeemed-popup-subtitle, .redeemed-popup-subtitle span {
		font-size: 14px;
		font-weight: 700;
		text-align: center;
	}

	.redeemed-popup-item {
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		gap: 14px;
		width: 100%;
		padding: 12px;
		border-radius: 12px;
		background-color: var(--color-bg-2);
		box-shadow: inset 0 0 3px var(--color-box-shadow-3);

		.redeemed-item-image {
			width: 64px;
			height: 64px;
			min-width: 64px;
			object-fit: contain;
			border-radius: 10px;
		}

		.redeemed-item-info {
			min-height: 64px;
			width: calc(100% - 110px);
			display: flex;
			flex-direction: column;
			justify-content: center;
			gap: 4px;

			.redeemed-item-name {
				font-size: 16px;
				font-weight: bold;
			}

			.item-products {
				display: flex;
				flex-direction: column;
				gap: 2px;

				.item-product, .item-product span {
					font-size: 13px;
					line-height: 16px;
					color: var(--color-txt-1);
				}
			}

			&.quantity-wrapper {
				width: 46px;
				text-align: right;
				height: 100%;
				display: flex;
				flex-direction: column;

				.redeemed-item-quantity {
					font-size: 14px;
					color: var(--color-txt-1);

					b {
						font-size: 16px;
						color: var(--txt-0);
					}
					&.small {
						font-size: 12px;
					}
				}
			}
		}
	}
}
</style>
